import GamepageTemplate from "../components/containers/GamepageTemplate";

const Sideattack = () =>{
    return(
        <GamepageTemplate 
            backgroundPng={"sideattack"}
            gameTitle={"Burnin' Rubber Sideattack"}
            gameDescription={"Become a road mercenary and reach the ultimate plan for the biggest payment ever"}
            embedYouTubeId={"oL0wKyEqmRc?si=1yd5eX4PT2sSKBsM"}
            downloadPath={"https://drive.google.com/uc?id=1UWmDl1QzrqM6_tvIv1Gs7M7F7pL32edZ"}
            gameVersion={"2.0"}
            versionDate={"2021-03"}
        />  
    );
};

export default Sideattack;
